import "./App.css";

// react
import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

// components
import Login from "./Login/Login";
import Menu from "./Menu/Menu";
import Loading from "./Loading/Loading";

function App() {
  const [login, setLogin] = useState("loading");

  useEffect(() => {
    setLogin(localStorage.getItem("logged") ? true : false);
  }, []);

  const beginLogin = async () => {
    window.location.reload(false);
  };

  const selectScreen = () => {
    switch (login) {
      case "loading":
        return <Loading />;
      case true:
        return <Menu login={login} logout={() => setLogin(false)} />;
      default:
        return <Login login={beginLogin} />;
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
      }}
    >
      <Routes>
        <Route path="/" element={selectScreen()} />
      </Routes>
    </div>
  );
}

export default App;
